const STATUS_PLAYING_INDEX = 0
const STATUS_TRACK_COUNT_INDEX = 1
const STATUS_TRANSPORT_GENERATION_INDEX = 2

export interface SharedMixerStateBuffers {
  gainsSab: SharedArrayBuffer
  statusSab: SharedArrayBuffer
}

export interface SharedMixerState extends SharedMixerStateBuffers {
  gains: Float32Array
  status: Int32Array
}

export function createSharedMixerState(trackCount: number): SharedMixerState {
  const statusSab = new SharedArrayBuffer(Int32Array.BYTES_PER_ELEMENT * 3)
  const gainsSab = new SharedArrayBuffer(Float32Array.BYTES_PER_ELEMENT * (trackCount + 1))

  const status = new Int32Array(statusSab)
  const gains = new Float32Array(gainsSab)

  status[STATUS_TRACK_COUNT_INDEX] = trackCount
  gains[0] = 1

  for (let index = 0; index < trackCount; index++) {
    gains[index + 1] = 1
  }

  return { gains, gainsSab, status, statusSab }
}

export function attachSharedMixerState(buffers: SharedMixerStateBuffers): SharedMixerState {
  return {
    gains: new Float32Array(buffers.gainsSab),
    gainsSab: buffers.gainsSab,
    status: new Int32Array(buffers.statusSab),
    statusSab: buffers.statusSab,
  }
}

export function getTrackCount(state: SharedMixerState): number {
  return state.status[STATUS_TRACK_COUNT_INDEX]
}

export function isPlaying(state: SharedMixerState): boolean {
  return Atomics.load(state.status, STATUS_PLAYING_INDEX) === 1
}

export function setPlaying(state: SharedMixerState, playing: boolean): void {
  Atomics.store(state.status, STATUS_PLAYING_INDEX, playing ? 1 : 0)
}

export function bumpTransportGeneration(state: SharedMixerState): number {
  return Atomics.add(state.status, STATUS_TRANSPORT_GENERATION_INDEX, 1) + 1
}

export function getTransportGeneration(state: SharedMixerState): number {
  return Atomics.load(state.status, STATUS_TRANSPORT_GENERATION_INDEX)
}

export function setMasterGain(state: SharedMixerState, gain: number): void {
  state.gains[0] = gain
}

export function getMasterGain(state: SharedMixerState): number {
  return state.gains[0]
}

export function setTrackGain(state: SharedMixerState, trackIndex: number, gain: number): void {
  state.gains[trackIndex + 1] = gain
}

export function getTrackGain(state: SharedMixerState, trackIndex: number): number {
  return state.gains[trackIndex + 1] ?? 0
}
